module.exports = __webpack_public_path__ + "static/img/empty_state.9878c9ea.png";